import {Component, ContentChild, Input, OnInit, TemplateRef} from '@angular/core';
import {fadeIn} from "../../animations/basic-animation";
import {fadeSmooth} from "../../animations/router-animation";

@Component({
  selector: 'tgsd-view-details-item',
  templateUrl: './tgsd-view-details-item.component.html',
  styleUrls: ['./tgsd-view-details-item.component.scss'],
  animations: [fadeIn, fadeSmooth]
})
export class TgsdViewDetailsItemComponent implements OnInit {

  @Input() key: string;
  @Input() value: any;
  @Input() color = '';
  @Input() valueType: string | 'number' | 'html' | 'date' | 'translate';
  @Input() otherClasses: string;
  @Input() hasBorder: boolean = false;
  @ContentChild(TemplateRef, {static: true}) customView: TemplateRef<any>;

  constructor() {
  }

  ngOnInit(): void {
  }

}
